export const CARD_SLIDER_LOAD_MORE_SCROLL_RATIO = 0.7;
export const LOAD_MORE_SKELETON_COUNT = 8;
